import { skyCMP } from '../../utils/sky-cmp';
import { insertAfter, createDomElement, injectScriptOnHead } from '../../utils/dom-utils';
import { onLmpTabChange } from '../../utils/aem-utils';
import { removeFromArray } from '../../utils/array-utils';

import { hasInlineCardAfterSecondParagraph, hasInlineCardBetweenFirstParagraphs } from './helpers';

const HOOK_OUTBRAIN_MAIN = '.j-outbrain';
const HOOK_OUTBRAIN_INTEXT = '.j-outbrain-intext';
const OUTBRAIN_CLASSNAME = 'OUTBRAIN';
const LMP_CSS_CONTENT_PREFIX = 'ftbl__tabs-switch__content-';

/**
 * Outbrain widget after first article paragraph
 * @param {DOM Element} $node
 * @param {boolean} addScript
 * @param {string} lmpTabId - When this has a value we are inside a live-match-pages tab
 */
const initOutbrainInnerText = ($node, addScript, lmpTabId) => {
  // If on LMP, we select the content inside the active tab
  const articleChildrenSelector = lmpTabId
    ? `#${LMP_CSS_CONTENT_PREFIX}${lmpTabId} .j-article-section > p, #${LMP_CSS_CONTENT_PREFIX}${lmpTabId} .j-article-section > a.j-inline-card`
    : `.j-article-section > p, .j-article-section > a.j-inline-card`;
  const articleParagraphsSelector = lmpTabId
    ? `#${LMP_CSS_CONTENT_PREFIX}${lmpTabId} .j-article-section > p`
    : `.j-article-section > p`;

  const $articleChildren = document.querySelectorAll(articleChildrenSelector);
  const $articleParagraphs = document.querySelectorAll(articleParagraphsSelector);

  const $articleChildrenNoEmpty = Array.from($articleChildren).filter(($item) => $item.textContent.trim().length > 0);
  const $articleParagraphsNoEmpty = Array.from($articleParagraphs).filter(
    ($item) => $item.textContent.trim().length > 0
  );

  // In case the article has less than 2 paragraphs
  if (!$articleParagraphsNoEmpty[1]) {
    return;
  }

  if (hasInlineCardBetweenFirstParagraphs($articleChildrenNoEmpty)) {
    removeFromArray($articleChildrenNoEmpty, 1); // remove first inline-card from the array
  }

  // create the element for inject in the page
  const divElement = createDomElement('div', {
    'data-src': $node.dataset.url,
    'data-widget-id': $node.dataset.widgetId,
    'data-intcmp': $node.dataset.intcmp,
  });
  divElement.classList.add(OUTBRAIN_CLASSNAME);

  if (addScript) {
    const src = $node.dataset.srcjs;
    const $script = createDomElement('script', {
      async: true,
      src,
    });
    injectScriptOnHead($script, src);
  }

  if (hasInlineCardAfterSecondParagraph($articleChildrenNoEmpty)) {
    insertAfter($articleChildrenNoEmpty[2], divElement);
  } else {
    insertAfter($articleChildrenNoEmpty[1], divElement);
  }
};

/**
 * Outbrain widget in article body
 */
const initOutbrainMain = ($node) => {
  const src = $node.dataset.srcjs;
  const $script = createDomElement('script', {
    async: true,
    src,
  });
  injectScriptOnHead($script, src);
};

const getIsInitialized = ($node) => $node?.dataset.initialized;
const setIsInitialized = ($node) => {
  $node.dataset.initialized = true;
};

/**
 * Outbrain widget initialization base on CMP consent
 */
export const init = ({ $outbrainMain, $outbrainInText }) => {
  skyCMP.onLoadOrInteraction(() => {
    if ($outbrainMain && !getIsInitialized($outbrainMain)) {
      initOutbrainMain($outbrainMain);
      setIsInitialized($outbrainMain);
    }
    if ($outbrainInText && !getIsInitialized($outbrainInText)) {
      initOutbrainInnerText($outbrainInText, !$outbrainMain);
      setIsInitialized($outbrainInText);
    }

    onLmpTabChange((e) => {
      const tabId = e.detail.id;
      const $outbrainInTextNode = document.querySelector(`#${LMP_CSS_CONTENT_PREFIX}${tabId} ${HOOK_OUTBRAIN_INTEXT}`);
      const $outbrainMainNode = document.querySelector(`#${LMP_CSS_CONTENT_PREFIX}${tabId} ${HOOK_OUTBRAIN_MAIN}`);
      if (!getIsInitialized($outbrainMainNode)) {
        setTimeout(() => {
          initOutbrainMain($outbrainMainNode);
          setIsInitialized($outbrainMainNode);
        }, 500);
      }
      if (!getIsInitialized($outbrainInTextNode)) {
        setTimeout(() => {
          initOutbrainInnerText($outbrainInTextNode, !$outbrainMainNode, tabId);
          setIsInitialized($outbrainInTextNode);
        }, 500);
      }
      window.OBR?.extern?.reloadWidget();
    });
  });
};
